@if (state() !== 'hidden') {
  <!-- Asymmetric corners echo the page title's icon badge, the app's signature shape -->
  <div
    [animate.enter]="'slide-in-bottom'"
    [animate.leave]="'slide-out-bottom'"
    [class]="state() === 'saved' ? 'bg-emerald-600' : 'bg-primary-500'"
    class="sticky bottom-0 z-20 mt-4 flex flex-wrap items-center justify-between gap-x-6 gap-y-3 rounded-tl-xl rounded-br-xl px-6 py-4 shadow-lg shadow-slate-900/25 transition-colors duration-300">

    <p aria-live="polite" class="m-0 flex items-center gap-3 text-base font-medium text-white" role="status">
      <elcia-dot [class.animate-pulse]="state() !== 'saved'" [color]="dotColor()"/>
      {{ message() | translate }}
    </p>

    @if (state() !== 'saved') {
      <div class="flex items-center gap-2">
        <elcia-button
          (onClick)="onDiscard.emit()"
          [disabled]="isSaving()"
          [label]="'action.discard' | translate"
          [severity]="'contrast'"
          [variant]="'outlined'"
          class="save-bar__discard"/>
        <elcia-button
          (onClick)="requestSave()"
          [icon]="'save'"
          [isLoading]="isSaving()"
          [label]="saveLabel() | translate"
          class="save-bar__save"
          data-testid="save-bar-save"/>
      </div>
    }
  </div>
}
